import Supplement from './Supplement'

class DraftSupplement extends Supplement {
  static urlRoot() {
    return '/payroll/draft_supplements'
  }
}

export default DraftSupplement
